import React from 'react';
import { ReferenceField as ReactAdminReferenceField } from 'react-admin';
import { useTheme } from '@mui/material';

export const getChildrenProps = (props) => ({
  label: props.label,
  fullWidth: props.fullWidth,
  'data-testid': props['data-testid'],
});

const ReferenceField = (props) => {
  const theme = useTheme();
  return (
    <ReactAdminReferenceField
      options={{
        suggestionsContainerProps: {
          style: { zIndex: theme.zIndex.tooltip },
        },
      }}
      {...props}
      filter={{
        ...props.filter,
        _input: {
          optionText: props.children.props.optionText,
          gql: props.gql,
        },
      }}
    />
  );
};

export default ReferenceField;
